// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1oElt","content":"styles_content__3fgfK","checkbox":"styles_checkbox__3uZrf","checkboxLabel":"styles_checkboxLabel__1GWlz"};